import { useMutation } from "@apollo/client/react";

import { ManagedUserGroupCreateInputV2 } from "types/generated";

import { CREATE_MANAGED_USER_GROUP } from "../gql";

const useAddGroup = () => {
  const [createManagedUserGroup] = useMutation(CREATE_MANAGED_USER_GROUP, {
    refetchQueries: ["GetManagedUserGroupsV2"],
  });

  const onCreate = (formData: ManagedUserGroupCreateInputV2) => {
    return createManagedUserGroup({
      variables: {
        input: formData,
      },
    });
  };

  return { onCreate };
};

export default useAddGroup;
